class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    this.fetchRecommendations();

    document.addEventListener("cart:change", () => {
      console.log("cart:change");
      this.fetchRecommendations();
    });
  }

  get productId() {
    return this.getAttribute("data-id");
  }

  get sectionId() {
    return this.getAttribute("data-section_id");
  }

  async fetchRecommendations() {
    console.log("productId", this.productId);
    console.log("sectionId", this.sectionId);
    try {
      const response = await fetch(
        `/recommendations/products?section_id=${this.sectionId}&product_id=${this.productId}&limit=3&intent=related`
      );
      const text = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, "text/html");
      const cart_html = html.querySelector("#cart-recommendations-container");
      const cart_real = document.querySelectorAll(
        "#cart-recommendations-container"
      );

      cart_real.forEach((recommendation) => {
        recommendation.innerHTML = cart_html.innerHTML;
      });
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define("cart-recommendations", CartRecommendations);
